"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngularMicrofrontendFactory = void 0;
var core_1 = require("../core");
var helpers_1 = require("../../../helpers");
var LinkEventHandler_1 = require("./LinkEventHandler");
function AngularMicrofrontendFactory(_a) {
    var BehaviorSubject = _a.BehaviorSubject, AppProps = _a.AppProps, Subject = _a.Subject;
    var Class = /** @class */ (function (_super) {
        __extends(Class, _super);
        function Class(appProps) {
            var _this = _super.call(this) || this;
            _this.propsBehaviorSubject = new BehaviorSubject(appProps);
            _this.remoteSubject = Subject ? new Subject() : undefined;
            return _this;
        }
        Object.defineProperty(Class.prototype, "remoteDependencies", {
            get: function () {
                return [];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Class.prototype, "props", {
            get: function () {
                return this.propsBehaviorSubject.getValue();
            },
            enumerable: false,
            configurable: true
        });
        Class.prototype.setProps = function (newAppProps) {
            this.propsBehaviorSubject.next(newAppProps);
        };
        Class.prototype.setRemotesImport = function () {
            this.remoteSubject.next();
        };
        Class.prototype.importRemotes = function () {
            (0, core_1.importAngularRemotes)(this.propsBehaviorSubject, this.remoteDependencies).catch(function (err) { return helpers_1.ConsoleHelper.error(err); });
        };
        Class.prototype.ngAfterViewInit = function () {
            var _this = this;
            this.remoteSubject
                ? this.remoteSubject.subscribe(function () { return _this.importRemotes(); })
                : this.importRemotes();
        };
        return Class;
    }(LinkEventHandler_1.LinkEventHandler));
    return Class;
}
exports.AngularMicrofrontendFactory = AngularMicrofrontendFactory;
